import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { User } from 'frontend-utils/models';

interface ProductAccessRights {
  is_accessible: boolean;

  is_editable: boolean;
}

interface ProductPermissions {
  rate_insight: ProductAccessRights;

  revenue_insight: ProductAccessRights;
}

export default class Userhotelrelationship extends Model {
  [Type] = 'userhotelrelationship' as const;

  @belongsTo('user', { async: true, inverse: 'userhotelrelationships' })
  declare user: User;

  @attr('string') declare accessRight: string;
  @attr('string') declare brandCode: string;
  @attr('string') declare createdAt: string;
  @attr('boolean') declare isDeletable: boolean;
  @attr('boolean') declare isLocked: boolean;
  @attr() declare products: ProductPermissions;
  @attr('string') declare subscriptionDescription: string;
  @attr('number') declare subscriptionId: number;
  @attr('string') declare subscriptionName: string;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get name() {
    if (this.brandCode !== null) {
      return `${this.brandCode} - ${this.subscriptionName}`;
    }

    return this.subscriptionName;
  }
}
